import eases from 'eases';
import { isObject, } from './isObject';
import { BrandColoursType, isBrandColour, } from '../resources';

export type ValidEasingsType = keyof typeof eases;
export const ValidEasings = Object.keys(eases) as ReadonlyArray<ValidEasingsType>;

export interface CounterData {
	id: number;
	colour: BrandColoursType;
	icon: string;
	title: string;
	value: number;
	duration?: number;
	easing?: ValidEasingsType;
}

export function CounterDataValidator(value: unknown): value is CounterData {
	return (
		true &&
		isObject(value) &&
		typeof value.id === 'number' &&
		typeof value.colour === 'string' &&
		isBrandColour(value.colour) &&
		typeof value.icon === 'string' &&
		typeof value.title === 'string' &&
		typeof value.value === 'number' &&
		(value.duration === null || value.duration === undefined || typeof value.duration === 'number') &&
		(value.easing === null || value.easing === undefined || (typeof value.easing === 'string' && (ValidEasings as string[]).includes(value.easing))) &&
		true
	);
}
